// src/composables/useWorkflowCounter.js
import { ref, onMounted } from "vue";

/**
 * @param {string} tabId - 'potting', 'welding', 'binding'
 */
export function useWorkflowCounter(tabId) {
  const storageKey = `workflow_count_${tabId}`;
  const count = ref(0);

  // 1. 挂载时从 localStorage 读取
  onMounted(() => {
    count.value = 0;
  });

  // 2. 增加计数
  const increment = () => {
    count.value++;
    localStorage.setItem(storageKey, count.value);
  };

  // 3. 重置计数
  const reset = () => {
    count.value = 0;
    localStorage.setItem(storageKey, 0);
  };

  return {
    count,
    increment,
    resetCounter: reset, // 避免与组件内的 resetWorkflow 命名冲突
  };
}
